const sfSubscriptionTiers = ['basic', 'cart', 'complete', 'advanced'];
const menuListWithMinimumRequirements = {
  "/admin/storefront/styling": 0,
  "/admin/storefront/menu": 0,
  "/admin/storefront/footer": 0,
  "/admin/storefront/pages/orders": 0,
  "/admin/storefront/pages/cartLayout": 0, // This can only be displayed for cart
  "/admin/card_layouts": 1,
  "/admin/storefront/pages/shop": 1,
  "/admin/storefront/pages": 2,
  "/admin/storefront/pages/GettheLook": 2,
  "/admin/storefront/domain": 2,
  "/admin/storefront/themes": 2,
  "/admin/torefront/pages/custom/": 2,
  "/admin/storefront/testimonials": 2,
  "/admin/storefront/socialMedia": 2,
  "/admin/storefront/seo": 3
}

export const storefrontSettingLocked = (menuUrl, sfTier) => {
  const tierIndex = sfSubscriptionTiers.indexOf(sfTier);
  let menuRequirement = menuListWithMinimumRequirements[menuUrl];

  return menuRequirement > tierIndex;
};
